import * as React from "react";

// NOTE (Yuxin, 2026-07-25): The beta intro walkthrough video, shown under the "Join the Replo Agent Beta" heading so the showcase carousel stays identical to agent onboarding.
const BETA_INTRO_VIDEO_ID = "uT8QlwYIy-I";

export const BetaIntroVideo: React.FC<{
  // Fires once on first click into the video (window-blur trick; the iframe swallows pointer events).
  onFirstPlay?: () => void;
}> = ({ onFirstPlay }) => {
  const iframeRef = React.useRef<HTMLIFrameElement | null>(null);
  const hasFiredRef = React.useRef(false);

  // eslint-disable-next-line replo/no-use-effect -- Subscribes to window blur (an external browser event) to detect clicks inside the cross-origin iframe.
  React.useEffect(() => {
    if (!onFirstPlay) {
      return;
    }
    const handleWindowBlur = () => {
      if (
        !hasFiredRef.current &&
        document.activeElement === iframeRef.current
      ) {
        hasFiredRef.current = true;
        onFirstPlay();
      }
    };
    window.addEventListener("blur", handleWindowBlur);
    return () => window.removeEventListener("blur", handleWindowBlur);
  }, [onFirstPlay]);

  return (
    <div className="aspect-video w-full overflow-hidden rounded-xl bg-default shadow-sm">
      {/* oxlint-disable-next-line react-doctor/iframe-missing-sandbox -- NOTE (Yuxin, 2026-07-25): YouTube playback requires scripts and same-origin access. */}
      <iframe
        ref={iframeRef}
        src={`https://www.youtube-nocookie.com/embed/${BETA_INTRO_VIDEO_ID}?rel=0`}
        title="A message from Replo"
        className="size-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts"
        allowFullScreen
      />
    </div>
  );
};
